import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "recentProjects" }
const _hoisted_2 = { class: "recentProjectsWrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("RECENTE "),
  /*#__PURE__*/_createElementVNode("span", null, "PROJECTEN")
], -1)
const _hoisted_4 = { class: "projectsList" }
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("ONTDEK MEER")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectItemComponent = _resolveComponent("ProjectItemComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
          return (_openBlock(), _createBlock(_component_ProjectItemComponent, {
            class: "recentProjectItem",
            item: project,
            key: project.id
          }, null, 8, ["item"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "calltoaction",
          to: "/projects"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}